import { eventEmitterFactory } from './Factory'

export const AppEventBus = eventEmitterFactory<symbol>()
